import { render, staticRenderFns } from "./SmplEditAbout.vue?vue&type=template&id=43321432&scoped=true&"
import script from "./SmplEditAbout.vue?vue&type=script&lang=js&"
export * from "./SmplEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43321432",
  null
  
)

export default component.exports